import { render } from "./App.vue?vue&type=template&id=7649f97f&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=7649f97f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7649f97f"

export default script